import { getUsers, updateAccount, exportAccounts } from '../../../modules/users/users.repository';
import { SortableAccountColumns, SortOrders, Account, UpdateAccountPayload, AccountStatus, GetAccountsResponse } from '../../../modules/users/types';
import { getInvitations, deleteInvitation } from '../../../modules/users/invitations/userInvitations.repository';
import { SortableAccountInvitationColumns, sortableAccountInvitationsColumns, AccountInvitation, GetAccountInvitationsResponse } from '../../../modules/users/invitations/types';

export const getUsersListUseCase = async (
  page: number,
  perPage: number,
  query?: string,
  sortBy?: SortableAccountColumns,
  sortOrder?: SortOrders,
): Promise<GetAccountsResponse> => {
  const response = await getUsers(page, perPage, query, sortBy, sortOrder);
  //manually update statuses within each account object with the correct defaults
  return {
    ...response,
    items: response.items.map((user) => {
      //if the status is null or verified, use default status 'activated'
      if (!user.status || user.status === AccountStatus.verified) {
        user.status = AccountStatus.activated;
      }
      //if the user is disabled then use 'disabled' status
      if (!user.enabled) {
        user.status = AccountStatus.disabled;
      }
      return user;
    }),
  };
};
export const getUsersInvitationsUseCase = (
  page: number,
  perPage: number,
  query?: string,
  sortBy?: SortableAccountColumns,
  sortOrder?: SortOrders,
): Promise<GetAccountInvitationsResponse> => {
  let accountInvitationSortBy: SortableAccountInvitationColumns | undefined;
  if (sortBy) {
    accountInvitationSortBy = sortableAccountInvitationsColumns.includes(sortBy as SortableAccountInvitationColumns)
      ? sortBy as SortableAccountInvitationColumns : undefined;
  }

  return getInvitations(page, perPage, query, accountInvitationSortBy, sortOrder);
};

export const deleteInvitationUseCase = async (
  id: number,
): Promise<void> => {
  await deleteInvitation(id);
};

export const exportAccountsUseCase = async (): Promise<string> => {
  return exportAccounts();
};

export const updateAccountUseCase = async (id: number, payload: UpdateAccountPayload): Promise<Account> => {
  return updateAccount(id, payload);
};
